import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import { get, isEmpty, map } from 'lodash';
import { push } from 'react-router-redux';
import Bookings from '../../../../api/api-bookings';
import DateTime from '../../app-bookings-request/DateTime';
import RequiredLabel from '../../elements-inputs/RequiredLabel';
import NumberField from '../../app-main/components/reduxForms/fields/NumberField/NumberField';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import ToggleField from '../../app-main/components/reduxForms/fields/ToggleField/ToggleField';

class BookingDetails extends Component {
  componentDidMount () {
    const { accessToken, routeParams, dispatch, spaceRental, contract, displayedAddOns, previousLocation } = this.props;
    const bookingId = get(routeParams, 'id', '');
    Bookings.readStatus(bookingId, accessToken, (response) => {
      if (!response.can_guest_update) {
        return dispatch(push(`/inbox/${bookingId}`));
      }
    });

    const listing = get(spaceRental, 'meta.listing', {});
    const pendingBookingContracts = get(contract, 'quote.pending.children', []);
    pendingBookingContracts.push(get(contract, 'quote.pending.master', {}));
    const bookingContracts = !isEmpty(pendingBookingContracts[0]) ? pendingBookingContracts : get(contract, 'contracts', {});
    const prevLocation = get(previousLocation, 'pathname');
    analyticsIntegrations.messageTrack('guest update booking form viewed', listing, bookingContracts, {}, displayedAddOns, prevLocation);
  }

  render () {
    const {
      dispatch,
      schedule,
      scheduleInput,
      formName,
      getFeeCalc,
      handleAttendeesChange = null,
      maxAttendees,
      spaceId = '',
      spaceRental,
      contractQuoteError = ''
    } = this.props;
    const booking = get(spaceRental, 'meta.booking', {});
    const listingData = get(spaceRental, 'meta.listing', {});

    return (
      <div>
        <div className="text-gray-600 margin-xl-bottom">
          <FormattedMessage
            id="inbox_guest_update_booking.booking_details.details_changed"
            defaultMessage="If the booking details have changed, you can update them here."
          />
        </div>

        <div className="margin-lg-bottom">
          <RequiredLabel text={ this.props.intl.formatMessage({ id: 'inbox_guest_update_booking.booking_details.date_time', defaultMessage: 'Date & Time' })} className="capitalize" />
          <FieldArray
            name="scheduleInput"
            component={DateTime}
            schedule={schedule}
            scheduleInput={scheduleInput}
            optional={false}
            spaceId={spaceId}
            dispatch={dispatch}
            getFeeCalc={getFeeCalc}
            formName={formName}
            excludeBookingIds={[booking._id]}
            multiday
            isLabel
            country={get(listingData, 'country', '')}
          />

          <div className="help-block text-red">
            { map(contractQuoteError.split('\n'), (item) => (
              <span key={item} data-testing-id="contract-quote-error">
                {item}
                <br />
              </span>)) }
          </div>
        </div>

        <div className="margin-xl-bottom">
          <RequiredLabel text={ this.props.intl.formatMessage({ id: 'inbox_guest_update_booking.booking_details.attendees', defaultMessage: 'Attendees' })} />
          <Field
            name="number_of_guests"
            component={NumberField}
            attributes={{ 'data-testing-id': 'number-guests-field' }}
            parse={value => Number(value) || null}
            placeholder={ this.props.intl.formatMessage({ id: 'inbox_guest_update_booking.booking_details.max_capacity', defaultMessage: 'Max capacity is {attendees}' }, { attendees: maxAttendees }) }
            onBlur={handleAttendeesChange}
          />
        </div>

        <div className="flex column margin-xl-bottom padding-xl-top">
          <RequiredLabel
            text={ this.props.intl.formatMessage({
              id: 'inbox_guest_update_booking.review_update.alcohol_consumed',
              defaultMessage: 'Will alcohol be consumed?'
            }) } />
          <Field
            name="alcohol_consumed"
            component={ToggleField}
            attributes={{
              'data-testing-id': 'alcohol-consumed-toggle',
              name: 'alcohol_consumed'
            }}
            firstOption={
              {
                id: 'alcohol-consumed-true',
                value: 'true',
                label: this.props.intl.formatMessage({
                  id: 'inbox_guest_update_booking.review_update.yes',
                  defaultMessage: 'Yes'
                })
              }}
            secondOption={
              {
                id: 'alcohol-consumed-false',
                value: 'false',
                label: this.props.intl.formatMessage({
                  id: 'inbox_guest_update_booking.review_update.no',
                  defaultMessage: 'No'
                })
              }
            }
          />
        </div>
      </div>
    );
  }
}

BookingDetails.propTypes = {
  accessToken: PropTypes.string,
  dispatch: PropTypes.func,
  spaceRental: PropTypes.object,
  contract: PropTypes.object,
  displayedAddOns: PropTypes.array,
  schedule: PropTypes.array,
  scheduleInput: PropTypes.array,
  formName: PropTypes.string,
  getFeeCalc: PropTypes.func,
  handleAttendeesChange: PropTypes.func,
  maxAttendees: PropTypes.number,
  spaceId: PropTypes.string,
  addOnsContracts: PropTypes.array,
  profile: PropTypes.object,
  contractQuoteError: PropTypes.string,
  intl: intlShape
};

export default injectIntl(BookingDetails);
